import { supabase } from "@/integrations/supabase/client";
import { CURRENT_CONSENT_VERSION } from "@/lib/legal-versions";

/**
 * Records user consent in the consent_records table.
 */
export async function recordConsent(
  userId: string,
  consentType: "registration" | "acknowledgment",
  language: string
) {
  const { error } = await supabase.from("consent_records").insert({
    user_id: userId,
    policy_version: CURRENT_CONSENT_VERSION,
    consent_type: consentType,
    language,
  });
  if (error) {
    console.error("❌ [Consent] Failed to record consent:", error);
  }
  return { error };
}

/**
 * Checks if a user has consented to the current policy version.
 */
export async function hasCurrentConsent(userId: string): Promise<boolean> {
  const { data, error } = await supabase
    .from("consent_records")
    .select("id")
    .eq("user_id", userId)
    .eq("policy_version", CURRENT_CONSENT_VERSION)
    .limit(1);

  if (error) {
    console.error("❌ [Consent] Failed to check consent:", error);
    return true; // fail open to not block users
  }
  return (data?.length ?? 0) > 0;
}
